const CorrigoConstants = {
    DARK_COLOR_THEME: '#5a7890',
    LIGHT_COLOR_THEME: '#eef3f4ff',

    // ---- Work Order Defaults ----
    DEFAULT_ASSET_ID: process.env.REACT_APP_DEFAULT_ASSET_ID, // "O-Other"
    DEFAULT_TASK_ID: process.env.REACT_APP_DEFAULT_TASK_ID, // "Other"
    WORK_ORDER_TYPE_ID: 4, // "Request"
    WORK_ORDER_SUBTYPE_ID: 259, // 259 corresponds to "Request" as sub type
    ACTOR_ID: 5049, //work order
    ADMIN_USER_ID: "-100",
    USER: "CorrigoNet",
    USER_TO_SHOW: "User",
    CORRIGO_ADMIN: "Employee",
    CORRIGO_ADMIN_TO_SHOW: "Admin",
    FIXED_CUSTOMER_ID:process.env.REACT_APP_FIXED_CUSTOMER_ID,
    CANCELLED_STATUS: "Cancelled",

    // ---- Custom Field Mappings ----
    CUSTOM_FIELDS: {
        RESIDENT_KEY: process.env.REACT_APP_RESIDENT_KEY,
        USER_ID: process.env.REACT_APP_USER_ID,
        COMMUNITY_ID: process.env.REACT_APP_COMMUNITY_ID,
        RESIDENT_ADDRESS: process.env.REACT_APP_RESIDENT_ADDRESS,
    },

    // ---- Upload Rules ----
    MAX_UPLOAD_SIZE_MB: 24,
    MAX_TITLE_LENGTH: 80,

    ALLOWED_DOC_EXTENSIONS: [
        "AVI", "BMP", "CSV", "DOC", "DOCX", "DWF", "DWG", "DXF", "FLV", "GIF", "HLP", "HQX",
        "HTM", "HTML", "HTTP", "JFIF", "JPE", "JPEG", "JPG", "MOV", "MP3", "MP4", "MPE",
        "MPEG", "MPG", "MPP", "OGG", "PDF", "PNG", "POT", "PPS", "PPT", "PPTX", "RTF",
        "SIT", "SVG", "TIF", "TIFF", "TXT", "VSD", "WAV", "WMF", "WMV", "WRI", "XLA",
        "XLC", "XLM", "XLS", "XLSX", "XLT", "XLW", "ZIP"
    ],
};

export const ALLOWED_DOC_EXTENSIONS_STRING = CorrigoConstants.ALLOWED_DOC_EXTENSIONS.join(", ");

export default CorrigoConstants;